import { render, staticRenderFns } from "./Error_404.vue?vue&type=template&id=67fdf566&scoped=true&"
import script from "./Error_404.vue?vue&type=script&lang=ts&"
export * from "./Error_404.vue?vue&type=script&lang=ts&"
import style0 from "./Error_404.vue?vue&type=style&index=0&id=67fdf566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fdf566",
  null
  
)

export default component.exports